import { render, staticRenderFns } from "./CreateJournalForm.vue?vue&type=template&id=9a4d015a&scoped=true&"
import script from "./CreateJournalForm.vue?vue&type=script&lang=js&"
export * from "./CreateJournalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4d015a",
  null
  
)

export default component.exports